import { Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, debounceTime } from 'rxjs';
import { ProtoApiService } from '../api/proto-api.service';

const REFRESH_DEBOUNCE_MS = 250;

/**
 * Counters and virtual date shown in the top bar. They refresh on navigation and after any write to the
 * prototype backend (see `shellRefreshInterceptor`), not on a timer.
 */
@Injectable({ providedIn: 'root' })
export class ShellStatusService {
  private readonly api = inject(ProtoApiService);
  private readonly requests = new Subject<void>();

  readonly unreadNotifications = signal(0);
  readonly trayCount = signal(0);
  readonly today = signal<string>('');

  constructor() {
    this.requests.pipe(debounceTime(REFRESH_DEBOUNCE_MS), takeUntilDestroyed()).subscribe(() => this.refresh());
  }

  requestRefresh(): void {
    this.requests.next();
  }

  /** The next user must not see the previous one's counters. */
  reset(): void {
    this.unreadNotifications.set(0);
    this.trayCount.set(0);
    this.today.set('');
  }

  refresh(): void {
    this.api.counters().subscribe({
      next: c => {
        this.unreadNotifications.set(c.unreadNotifications);
        this.trayCount.set(c.trayCount);
      },
      error: () => {},
    });
    this.api.clock().subscribe({
      next: c => this.today.set(c.today),
      error: () => {},
    });
  }

  advanceDays(days: number): void {
    this.api.advanceClock(days).subscribe({
      next: c => {
        this.today.set(c.today);
        this.refresh();
      },
      error: () => {},
    });
  }
}
